module.exports = __webpack_public_path__ + "img/room-02.e6ea2111.jpg";